import type { ReactElement } from "react"
import { useContext } from "react"
import React from "react"
import _t from "@core/i18n"
import TableMol from "@onestore/hel/dist/components/molecules/TableMol"
import type { TableMolProps } from "@onestore/hel/dist/components/molecules/TableMol"
import HeaderContext from "~/context/HeaderContext"
import { getTableAriaLabels } from "~/helpers/getTableAriaLabels"
import useHeaderHeightSpace from "~/hooks/useHeaderHeightSpace"
import { sendContentShowEvent } from "~/lib/analytics"

type TableMolWrapperProps = Omit<TableMolProps, "ariaLabels">

export default function TableMolWrapper({
  showMoreDetails,
  ...tableProps
}: TableMolWrapperProps): ReactElement {
  const headerHeightSpace = useHeaderHeightSpace()
  const { hasHeaderBottomBar } = useContext(HeaderContext)

  const showMoreDetailsWithOnClick = {
    ...showMoreDetails,
    onClick: sendContentShowEvent,
  }

  return (
    <TableMol
      showMoreDetails={showMoreDetailsWithOnClick}
      pushTopSpace={headerHeightSpace}
      hasHeaderBottomBar={hasHeaderBottomBar}
      ariaLabels={{
        ...getTableAriaLabels(),
        iconTrueAriaLabel: _t("tableAriaLabels.iconTrue"),
        iconFalseAriaLabel: _t("tableAriaLabels.iconFalse"),
      }}
      {...tableProps}
    />
  )
}
